import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class StaffGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
      if(this.auth.user().iscustomer != true){
        return true;
      }else{
        this.router.navigate(['/dashboard']);
        return false;
      }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/staff/staff.guard.ts